import React from 'react';
import PropTypes from 'prop-types';

import './MagstimTable.css'

import '../../html/fontawesome/css/all.min.css'
import './MagstimTable.css'

import { magstim_eventHandler } from './../magstim'

import './MagstimTableControl.css'
import * as TableControl from './MagstimTableControl.js'
import * as StringUtils from '../../utils/StringUtils.js'
import { CurrentLang, isPDA } from 'common/';

class MagstimTable extends React.Component {

	constructor() {
		super();
		this._divTable = React.createRef();
		this.tableSelectionChangedHandler.bind(this);
		this.tableCellClickHandler.bind(this);
		this.tablePrivacyModeChangedHandler.bind(this);
	}

	render() {

        var className = "item-margin";

        if(false === isPDA()){
            className = "item-margin device-table-wrapper";
        }

		return (
			<>
				<div className={className} id={this.props.div_name} ref={this._divTable}></div>
			</>
		);
	}

	// eslint-disable-next-line no-unused-vars
	formatSeconds(value, _column, _row) {
		return StringUtils.formatSeconds(value);
	}
	
	// eslint-disable-next-line no-unused-vars
	formatMinuteAndSeconds(value, _column, _row) {
		return StringUtils.formatMinuteAndSeconds(value);
	}

	// eslint-disable-next-line no-unused-vars
	formatDate(value, _column, _row) {
		return StringUtils.formatDate(value);
	}

    // eslint-disable-next-line no-unused-vars
	formatDateAndTime(value, _column, _row) {
		return StringUtils.formatDate(value, true);
	}

	// eslint-disable-next-line no-unused-vars
	formatUtcDate(value, _column, _row) {
		return StringUtils.formatUtcDate(value);
	}

	// eslint-disable-next-line no-unused-vars
	formatPercent(value, _column, _row) {
		return StringUtils.formatPercent(value);
	}

	// eslint-disable-next-line no-unused-vars
	formatPercentTo1DecimalPlace(value, _column, _row) {
		return StringUtils.formatPercentOrNoDataWithDecimalPlaces(value, CurrentLang().no_data, 1);
	}

	// eslint-disable-next-line no-unused-vars
	formatPercentTo2DecimalPlace(value, _column, _row) {
		return StringUtils.formatPercentOrNoDataWithDecimalPlaces(value, CurrentLang().no_data, 2);
	}

	// eslint-disable-next-line no-unused-vars
	formatBool(value, _column, _row) {
		var retVal;
		if ((undefined === value) || (null === value)) {
			retVal = CurrentLang().no_data;
		}
		else {
			retVal = value ? CurrentLang().yes : CurrentLang().no;
		}
		//console.log(`formatBool ${_column.property} : ${value} --> ${retVal}`);
		return retVal;
	}

	// eslint-disable-next-line no-unused-vars
	formatFraction(value, _column, _row) {
		return StringUtils.formatFraction(value);
	}

    // eslint-disable-next-line no-unused-vars
	formatStringOrNoData(value, _column, _row) {
		return StringUtils.formatStringOrNoData(value, CurrentLang().no_data);
	}

    // eslint-disable-next-line no-unused-vars
	formatTranslated(value, _column, _row) {
		return CurrentLang()[value];
	}

	tableSelectionChangedHandler = (event, isSelected, rows, row) => {
		// console.log('MagstimTable.tableSelectionChangedHandler '
		// 	+ ' event=' + JSON.stringify(event)
		// 	+ ' isSelected=' + isSelected
		// 	+ ' rows=' + JSON.stringify(rows)
		// 	+ ' row=' + JSON.stringify(rows)
		// );

		var eventData = [
			{ 'tableName': this.props.div_name },
			{ 'action': "selectionUpdated" },
			{ 'tableData': rows }
		];

		magstim_eventHandler("MagstimTable", eventData, null);

		if (this.props.selectionChangedCallback) {
			this.props.selectionChangedCallback(event, isSelected, rows, row);
		}
	}

	tableCellClickHandler = (row, column, cell) => {
		//console.log('MagstimTable.tableCellClickHandler '
		// 	+ ' row=' + JSON.stringify(row)
		// 	+ ' column=' + column
		// 	+ ' cell=' + JSON.stringify(cell)
		//);

		if (this.props.cellClickCallback) {
			this.props.cellClickCallback(row, column, cell);
		}
	}


	tablePrivacyModeChangedHandler = (privacyOn) =>{
		if (this.props.privacyModeChangedCallback) {
			this.props.privacyModeChangedCallback(privacyOn);
		}
	}

	clear() {
		// console.log(`MagstimTable.clear`);
		TableControl.clear(this.props.div_name);
	}
	
	initTable(tableData, heightPx, addNoDataWhenEmpty) {
		if (undefined === addNoDataWhenEmpty) {
			addNoDataWhenEmpty = false;
		}
		tableData.tableSelectionChangedHandler = this.tableSelectionChangedHandler;
		tableData.tableCellClickHandler = this.tableCellClickHandler;
		tableData.tablePrivacyModeChangedHandler = this.tablePrivacyModeChangedHandler;
		TableControl.initTable(this.props.div_name, tableData, this.adjustHeight(heightPx), addNoDataWhenEmpty);
	}

	initGroupedTable(tableData, heightPx, addNoDataWhenEmpty) {
		if (undefined === addNoDataWhenEmpty) {
			addNoDataWhenEmpty = false;
		}
		tableData.tableSelectionChangedHandler = this.tableSelectionChangedHandler;
		tableData.tableCellClickHandler = this.tableCellClickHandler;
		tableData.tablePrivacyModeChangedHandler = this.tablePrivacyModeChangedHandler;
		TableControl.initGroupedTable(this.props.div_name, tableData, this.adjustHeight(heightPx), addNoDataWhenEmpty);
	}

	resetFilters() {
		// console.log('MagstimTable.resetFilters');
		TableControl.resetFilters(this.props.div_name);
	}

	setFilter(propertyName, propertyValue) {
		// console.log('MagstimTable.setFilter ' + propertyName + ' = ' + propertyValue);
		TableControl.setFilter(this.props.div_name, propertyName, propertyValue);
	}

	addFilter(propertyName, propertyValue) {
		// console.log('MagstimTable.addFilter ' + propertyName + ' = ' + propertyValue);
		TableControl.addFilter(this.props.div_name, propertyName, propertyValue);
	}

	getFilteredData() {
		return TableControl.getFilteredData(this.props.div_name);
	}

	getColumns() {
		return TableControl.getColumns(this.props.div_name);
	}

	adjustHeight(heightPx) {
		return heightPx - 40 /* table-scroll margin-top*/;
	}

	setHeight(heightPx) {
		// console.log(`MagstimTable.setHeight(${heightPx})`);
		TableControl.setHeight(this.props.div_name, this.adjustHeight(heightPx));
	}

	search(searchText) {
		TableControl.search(this.props.div_name, searchText);
	}
	
	formatStatus = (value, column, row) => {
			
		const COLOR_LIGHT_PINK = '#FF4747';
		const COLOR_LIGHT_GREEN = '#88BB00';
		const COLOR_WHITE = '#FFFFFF';

		var label = document.createElement('p');
		label.innerText = value;
		label.style.borderRadius = '16px';
		label.style.padding = '8px';
		label.style.fontSize = 'small';
		label.style.width = '80px';
		label.style.textAlign = 'center';
		label.style.margin = '0px';

		if (value === 'Active') {
			label.style.background = COLOR_LIGHT_GREEN;
			label.style.color = COLOR_WHITE;
		}
		else {
			label.style.background = COLOR_LIGHT_PINK;
			label.style.color = COLOR_WHITE;
		}

		return label;
	}
}

MagstimTable.propTypes = {
	selectionChangedCallback: PropTypes.func,
	privacyModeChangedCallback: PropTypes.func,
    div_name: PropTypes.string
};

MagstimTable.defaultProps = {
	selectionChangedCallback: undefined,
	privacyModeChangedCallback: PropTypes.func,
    div_name: 'divTable'
};

export default MagstimTable;